import header from "./bauzeichnung-Mensch-Zeichnen.webp";
import section1 from "./bauzeichnung-digital.webp";
import section2 from "./bauzeichnung-ausfuehrungsplanung.webp";
import section3 from "./bauzeichnung-papier.webp";
import section4 from "./bauzeichnung-bedeutung.webp";

export { header, section1, section2, section3, section4};
